import { render, staticRenderFns } from "./CpurchasingUpdate.vue?vue&type=template&id=08763769&scoped=true"
import script from "./CpurchasingUpdate.vue?vue&type=script&lang=js"
export * from "./CpurchasingUpdate.vue?vue&type=script&lang=js"
import style0 from "./CpurchasingUpdate.vue?vue&type=style&index=0&id=08763769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08763769",
  null
  
)

export default component.exports